module.exports = __webpack_public_path__ + "media/assets/images/leanbit_home/nuvola_cloud-65965bf93ac0cea2f77edf5b93f9106d.svg";